import { MARKER_GROUP_TYPES, MarkerGroupType } from 'components/Map/constants/markerGroupTypes';
import { ROADSIDE_SERVICES_CODES } from 'common/constants/index';
import { STATION_TYPES } from 'common/constants/stationTypes';
import { checkIsStation } from 'common/utils/index';

import { Station } from 'dataSources/Typicode/stations/types/station';
import { StationType } from 'common/constants/stationTypes';

export interface MarkerType {
  markerType?: StationType;
  markerGroupType?: MarkerGroupType;
  roadsideServiceCode?: number;
}

const createMarkerType = (
  markerType?: StationType,
  markerGroupType?: MarkerGroupType,
  roadsideServiceCode?: number
): MarkerType => ({
  markerType,
  markerGroupType,
  roadsideServiceCode
});



const getStationType = (categoryCode: number) => ({
  2: STATION_TYPES.discountPlusPetrolStation,
  4: STATION_TYPES.powerMaxPetrolStation,
  5: STATION_TYPES.economyPetrolStation
}[categoryCode] || STATION_TYPES.petrolStation);

const getStationServiceType = (roadsideServiceCode: number) => ({
  [ROADSIDE_SERVICES_CODES.roadPay]: STATION_TYPES.roadPaymentPoint,
  [ROADSIDE_SERVICES_CODES.parking]: STATION_TYPES.parking,
  [ROADSIDE_SERVICES_CODES.carWash]: STATION_TYPES.carWash,
  [ROADSIDE_SERVICES_CODES.autoService]: STATION_TYPES.carService,
  [ROADSIDE_SERVICES_CODES.guard]: STATION_TYPES.convoy,
  [ROADSIDE_SERVICES_CODES.boat]: STATION_TYPES.ferry,
  [ROADSIDE_SERVICES_CODES.railway]: STATION_TYPES.railwayPlatform,
  [ROADSIDE_SERVICES_CODES.store]: STATION_TYPES.autoGoodsStore,
  [ROADSIDE_SERVICES_CODES.cafe]: STATION_TYPES.cafe,
  [ROADSIDE_SERVICES_CODES.truckWash]: STATION_TYPES.truckWash,
  [ROADSIDE_SERVICES_CODES.automobileWash]: STATION_TYPES.carWash
}[roadsideServiceCode]);

export const getMarker = (
  roadsideServiceCode: number,
  categoryCode: number
) => {
  if (checkIsStation(roadsideServiceCode)) {
    return createMarkerType(
      getStationType(categoryCode),
      MARKER_GROUP_TYPES.station,
      roadsideServiceCode
    );
  }

  return createMarkerType(
    getStationServiceType(roadsideServiceCode),
    MARKER_GROUP_TYPES.roadsideService,
    roadsideServiceCode
  );
};



export const getMarkerType = ({
  data
}: {
  data: Station;
}): MarkerType => {
  if (!data.code) {
    return {
      markerType: STATION_TYPES.place
    };
  }

  if (!data.roadsideServiceCodes.length) {
    return {
      markerType: STATION_TYPES.petrolStation,
      markerGroupType: MARKER_GROUP_TYPES.station
    };
  }

  if (Number(data.roadsideServiceCodes[0]) === ROADSIDE_SERVICES_CODES.gasStation) {
    return {
      markerType: getStationType(data.categoryCode),
      markerGroupType: MARKER_GROUP_TYPES.station,
      roadsideServiceCode: data.roadsideServiceCodes[0]
    };
  }

  return {
    markerType: getStationServiceType(data.roadsideServiceCodes[0]),
    markerGroupType: MARKER_GROUP_TYPES.roadsideService,
    roadsideServiceCode: Number(data.roadsideServiceCodes[0])
  }
};
